__turbopack_context__.v({
  "entitySelectorFade": "OtherEntitySelector-module__f9fSuG__entitySelectorFade",
  "otherEntitySelector": "OtherEntitySelector-module__f9fSuG__otherEntitySelector",
  "otherEntitySelectorVisible": "OtherEntitySelector-module__f9fSuG__otherEntitySelectorVisible",
  "otherEntitySelector__item": "OtherEntitySelector-module__f9fSuG__otherEntitySelector__item",
  "otherEntitySelector__itemActive": "OtherEntitySelector-module__f9fSuG__otherEntitySelector__itemActive",
  "otherEntity__filter": "OtherEntitySelector-module__f9fSuG__otherEntity__filter",
});
